module.exports = __webpack_public_path__ + "img/tfw_logo.043f9b33.png";